import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {navigateBack} from '../../router/actions';

export const fetchShiftsList = () => apiActionCreator({
  'endpoint': '/pickingShifts',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SHIFTS_LIST,
    ActionTypes.FETCHED_SHIFTS_LIST,
    [
      ActionTypes.FETCHED_SHIFTS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchShift = (code) => apiActionCreator({
  'endpoint': `/pickingShifts/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_SHIFT,
    ActionTypes.FETCHED_SHIFT,
    [
      ActionTypes.FETCHED_SHIFT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const addShift = (data) => apiActionCreator({
  'endpoint': '/pickingShifts',
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_SHIFT,
    [
      ActionTypes.ADDED_SHIFT,
      navigateBack(),
      MessageActions.addMessageBoxInfo('Corte añadido satisfactoriamente'),
    ],
    [
      ActionTypes.ADDED_SHIFT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const editShift = (code, data) => apiActionCreator({
  'endpoint': `/pickingShifts/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.SAVING_SHIFT,
    [
      ActionTypes.SAVED_SHIFT,
      navigateBack(),
      MessageActions.addMessageBoxInfo('Corte actualizado satisfactoriamente'),
    ],
    [
      ActionTypes.SAVED_SHIFT_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': data,
});

export const filterShifts = (value) => ({
  'type': ActionTypes.FILTER_SHIFTS,
  'payload': value,
});

export const changeShiftsTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_SHIFTS_TEXT_FILTER,
  'payload': value,
});
